var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.useOldFunctionalityForDays
        ? _c("old-date-convert-banner", { attrs: { id: _vm.festival.id } })
        : _vm._e(),
      _vm._v(" "),
      _c("h1", { staticClass: "mt-2 mb-4 font-sans text-n-gray-dark" }, [
        _vm._v("Festival"),
      ]),
      _vm._v(" "),
      !_vm.saving
        ? _c(
            "form",
            { staticClass: "md:max-w-lg", attrs: { method: "POST" } },
            [
              _c("div", { staticClass: "mb-12" }, [
                _c("label", { ref: "title", attrs: { for: "form.title" } }, [
                  _vm._v("\n        Title "),
                  _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.title,
                      expression: "form.title",
                    },
                  ],
                  attrs: { id: "title", type: "text", name: "title" },
                  domProps: { value: _vm.form.title },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "title", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("title"),
                        expression: "errors.has('title')",
                      },
                    ],
                    staticClass: "error text-error-red text-lg",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("title")))]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-12" }, [
                _c("label", { ref: "slug", attrs: { for: "slug" } }, [
                  _vm._v("\n        Slug "),
                  _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-sm font-sans-book" }, [
                    _vm._v(
                      "Enter the slug for the Festival entry in Craft. This is critical as it establishes the relationship between all events in this festival in HEMS with the Craft powered website."
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.slug,
                      expression: "form.slug",
                    },
                  ],
                  attrs: { id: "slug", type: "text", name: "slug" },
                  domProps: { value: _vm.form.slug },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "slug", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("slug"),
                        expression: "errors.has('slug')",
                      },
                    ],
                    staticClass: "error text-error-red text-lg",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("slug")))]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-12" }, [
                _c("label", { ref: "contract", attrs: { for: "contract" } }, [
                  _vm._v("\n        Contract "),
                  _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.contractId,
                        expression: "form.contractId",
                      },
                    ],
                    attrs: { id: "contract", name: "contract" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "contractId",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.contracts, function (contract) {
                    return _c(
                      "option",
                      { key: contract.id, domProps: { value: contract.id } },
                      [_vm._v(_vm._s(contract.title))]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("contract"),
                        expression: "errors.has('contract')",
                      },
                    ],
                    staticClass: "error text-error-red text-lg",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("contract")))]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-12" }, [
                _c("label", { ref: "hashtag", attrs: { for: "hashtag" } }, [
                  _vm._v("\n        Hashtag "),
                  _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-sm font-sans-book" }, [
                    _vm._v('Please do not include the Hashtag Symbol "#"'),
                  ]),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.hashtag,
                      expression: "form.hashtag",
                    },
                  ],
                  attrs: { id: "hashtag", type: "text", name: "hashtag" },
                  domProps: { value: _vm.form.hashtag },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "hashtag", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("hashtag"),
                        expression: "errors.has('hashtag')",
                      },
                    ],
                    staticClass: "error text-error-red text-lg",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("hashtag")))]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-12" }, [
                _c(
                  "label",
                  { ref: "thankYouUrl", attrs: { for: "thankYouUrl" } },
                  [
                    _vm._v("\n        Thank you url "),
                    _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-sm font-sans-book" }, [
                      _vm._v(
                        "This is the URL to the thank you page on the live website that the user will be redirected to after checking out using SquadUP"
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.thankYouUrl,
                      expression: "form.thankYouUrl",
                    },
                  ],
                  attrs: {
                    id: "thankYouUrl",
                    type: "text",
                    name: "thankYouUrl",
                  },
                  domProps: { value: _vm.form.thankYouUrl },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "thankYouUrl", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("thankYouUrl"),
                        expression: "errors.has('thankYouUrl')",
                      },
                    ],
                    staticClass: "error text-error-red text-lg",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("thankYouUrl")))]
                ),
              ]),
              _vm._v(" "),
              _c("time-zones", {
                attrs: { label: "Festival time zone" },
                model: {
                  value: _vm.form.timezone,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "timezone", $$v)
                  },
                  expression: "form.timezone",
                },
              }),
              _vm._v(" "),
              _vm.useOldFunctionalityForDays
                ? _c(
                    "div",
                    { staticClass: "mb-12" },
                    [
                      _c("label", { ref: "days", attrs: { for: "days" } }, [
                        _vm._v("\n        Days "),
                        _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "text-sm font-sans-book block" },
                          [
                            _vm._v(
                              "\n          Please enter the days that you would Hosts to be able to select from to create their events. If you enter a new date that is not in chronological order as the ones that preceded it, it will be ordered properly once you save the festival.\n        "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.form.days, function (day, index) {
                        return _c("day-selector", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          key: day.id,
                          attrs: {
                            id: "days",
                            name: "days",
                            arrayIndex: index,
                          },
                          on: { "remove-day": _vm.removeDay },
                          model: {
                            value: _vm.form.days[index],
                            callback: function ($$v) {
                              _vm.$set(_vm.form.days, index, $$v)
                            },
                            expression: "form.days[index]",
                          },
                        })
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("days"),
                              expression: "errors.has('days')",
                            },
                          ],
                          staticClass: "error text-error-red text-lg",
                        },
                        [_vm._v(_vm._s(_vm.errors.first("days")))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "py-3" }, [
                        _c(
                          "a",
                          {
                            staticClass: "text-black",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.addDay.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("Add Day")]
                        ),
                      ]),
                    ],
                    2
                  )
                : _c("div", [
                    _c(
                      "div",
                      { staticClass: "mb-12" },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("lab-admin-date-range-picker", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          attrs: { name: "festival start date", id: "startAt" },
                          model: {
                            value: _vm.form.startAt,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "startAt", $$v)
                            },
                            expression: "form.startAt",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("festival start date"),
                                expression: "errors.has('festival start date')",
                              },
                            ],
                            staticClass: "error text-error-red text-lg",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.errors.first("festival start date"))
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mb-12" },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("lab-admin-date-range-picker", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          attrs: {
                            "restricted-before-date": _vm.form.startAt,
                            name: "festival end date",
                            id: "endAt",
                          },
                          model: {
                            value: _vm.form.endAt,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "endAt", $$v)
                            },
                            expression: "form.endAt",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("festival end date"),
                                expression: "errors.has('festival end date')",
                              },
                            ],
                            staticClass: "error text-error-red text-lg",
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.errors.first("festival end date"))
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.form.startAt && _vm.form.endAt
                      ? _c("div", { staticClass: "mb-12" }, [
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mt-5" },
                            [
                              _c("lab-admin-date-exclusion-picker", {
                                attrs: {
                                  "start-at": _vm.form.startAt,
                                  "end-at": _vm.form.endAt,
                                },
                                model: {
                                  value: _vm.form.days,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "days", $$v)
                                  },
                                  expression: "form.days",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-12" },
                [
                  _c(
                    "label",
                    { ref: "gaStartDay", attrs: { for: "gaStartDay" } },
                    [
                      _vm._v("\n        General Admission Start Day "),
                      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("datepicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: {
                      id: "gaStartDay",
                      name: "gaStartDay",
                      format: "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.form.gaStartDay,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "gaStartDay", $$v)
                      },
                      expression: "form.gaStartDay",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("gaStartDay"),
                          expression: "errors.has('gaStartDay')",
                        },
                      ],
                      staticClass: "error text-error-red text-lg",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("gaStartDay")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-12" },
                [
                  _c(
                    "label",
                    {
                      ref: "loadGaStartTime",
                      attrs: { for: "loadGaStartTime" },
                    },
                    [
                      _vm._v("\n        General Admission Start Time "),
                      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-sm font-sans-book" }, [
                        _vm._v(
                          "Note time zone will match the time zone set for the festival. "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("time-picker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: { name: "loadGaStartTime" },
                    model: {
                      value: _vm.form.loadGaStartTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "loadGaStartTime", $$v)
                      },
                      expression: "form.loadGaStartTime",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("loadGaStartTime"),
                          expression: "errors.has('loadGaStartTime')",
                        },
                      ],
                      staticClass: "error text-error-red text-lg",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("loadGaStartTime")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-12" },
                [
                  _c("label", { ref: "gaEndDay", attrs: { for: "gaEndDay" } }, [
                    _vm._v("\n        General Admission End Day "),
                    _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                  ]),
                  _vm._v(" "),
                  _c("datepicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: {
                      id: "gaEndDay",
                      name: "gaEndDay",
                      format: "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.form.gaEndDay,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "gaEndDay", $$v)
                      },
                      expression: "form.gaEndDay",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("gaEndDay"),
                          expression: "errors.has('gaEndDay')",
                        },
                      ],
                      staticClass: "error text-error-red text-lg",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("gaEndDay")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-12" },
                [
                  _c(
                    "label",
                    { ref: "loadGaEndTime", attrs: { for: "loadGaEndTime" } },
                    [
                      _vm._v("\n        General Admission End Time "),
                      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-sm font-sans-book" }, [
                        _vm._v(
                          "Note time zone will match the time zone set for the festival. "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("time-picker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: { name: "loadGaEndTime" },
                    model: {
                      value: _vm.form.loadGaEndTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "loadGaEndTime", $$v)
                      },
                      expression: "form.loadGaEndTime",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("loadGaEndTime"),
                          expression: "errors.has('loadGaEndTime')",
                        },
                      ],
                      staticClass: "error text-error-red text-lg",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("loadGaEndTime")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mb-12" }, [
                _c("label", { attrs: { for: "allowEventCreation" } }, [
                  _vm._v("Allow Event Creation"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "select-box" }, [
                  _c(
                    "label",
                    {
                      staticClass: "text-base font-normal",
                      attrs: { for: "allowEventCreation" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.allowEventCreation,
                            expression: "form.allowEventCreation",
                          },
                        ],
                        attrs: { type: "checkbox", id: "allowEventCreation" },
                        domProps: {
                          checked: Array.isArray(_vm.form.allowEventCreation)
                            ? _vm._i(_vm.form.allowEventCreation, null) > -1
                            : _vm.form.allowEventCreation,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.form.allowEventCreation,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "allowEventCreation",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "allowEventCreation",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "allowEventCreation", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "check inline-block mr-2" }),
                      _vm._v(" Yes\n        "),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-4" }, [
                _c(
                  "button",
                  {
                    staticClass: "button",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.saveFestival.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Save")]
                ),
              ]),
            ],
            1
          )
        : _c("div", { staticClass: "text-2xl text-center mb-4" }, [
            _vm._v("Saving Event..."),
          ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "startAt" } }, [
      _vm._v("\n          Festival Start Date "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "endAt" } }, [
      _vm._v("\n          Festival End Date "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "endAt" } }, [
      _vm._v("\n          Festival Exclusion Days\n          "),
      _c("span", { staticClass: "text-sm font-sans-book block" }, [
        _vm._v(
          "\n            Use this to block out any days between the festival start and end dates from collaborators.\n            Dates highlighted in blue aren't excluded.\n          "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }